import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";

import DimensionSpinner from "components/DimensionSpinner/DimensionSpinner";
import useHelpers from "Hooks/useHelpers";
import useUserContext from "Hooks/useUserContext";
import useAlertContext from "Hooks/useAlertContext";
import useFetch from "Hooks/useFetch";

// This element exists so that the React front end can be connected to Procore's OAuth flow
// if Procore redirects to the backend, then the front end can't get any data back
export default function OAuth() {
    const location = useLocation();
    const navigate = useNavigate();
    const [, onSetUserContext] = useUserContext();
    const { newAlert } = useAlertContext();

    const { handleLoginCompanyOkResponse } = useHelpers();
    const { get, post } = useFetch();

    // Receive Procore authorization code and exchange it for a authorization token, then go to login company page
    useEffect(() => {
        let ignore = false;

        (async () => {
            const query = new URLSearchParams(location.search);
            const code = query.get("code");

            if (code && !ignore) {
                // This endpoint exchanges the code for an access token, and saves it to the database
                // and returns the user's companies
                const response = await get(`api/oauth?code=${code}`);
                const data = await response.json();

                if (response.ok && !ignore) {
                    console.log(data);

                    if (data.length === 0 && !ignore) {
                        newAlert({
                            color: "danger",
                            message:
                                "The Procore user does not have access to any companies.",
                        });
                        navigate("/login");
                        return;
                    } else if (data.length === 1 && !ignore) {
                        loginCompany(data[0].company_id);
                        return;
                    } else if (!ignore) {
                        onSetUserContext({
                            procoreLoginCompanies: data,
                        });
                        navigate("/login_company");
                        return;
                    }
                }
                newAlert({
                    color: "danger",
                    message: `${data.detail} Contact Calance for assistance.`,
                });
                navigate("/login");
                return;
            }

            newAlert({
                color: "danger",
                message:
                    "Unable to log in with Procore. Contact Calance for assistance.",
            });
            navigate("/login");
        })();

        async function loginCompany(company_id: string): Promise<void> {
            const response = await post(
                `/api/login_company?company_id=${company_id}`
            );
            const data = await response.json();
            console.log(data);

            if (response.ok) {
                handleLoginCompanyOkResponse(data);
            } else {
                newAlert({
                    color: "danger",
                    message: data.detail,
                });
            }
        }

        return () => {
            ignore = true;
        };
    }, [
        get,
        handleLoginCompanyOkResponse,
        location,
        navigate,
        newAlert,
        onSetUserContext,
        post,
    ]);

    const style = {
        width: "150px",
        height: "150px",
        bottom: "100px",
        position: "absolute",
    };

    return <DimensionSpinner style={style} />;
}
